import createRandomGenerator from './seededRandom'

const shuffleArray = (str: string, arr: any[]) => {
	const rArr = []
	const random = createRandomGenerator(str)
	while (arr.length > 1) {
		rArr.push(arr.splice(Math.floor(random() * arr.length), 1)[0])
	}
	rArr.push(arr[0])
	return rArr
}

export default shuffleArray
